module.exports = __webpack_public_path__ + "static/media/NTUEworkshop-1129-00002.ebc00741.jpg";